<div style="width: 100%; text-align: center;">
    <div class="contentContainer" style="margin-top: 100px;">

        <p style="font-weight: bold; font-size: 18px;">
            {{errMessage}}
        </p>
    </div>
</div>
